import { render, staticRenderFns } from "./NewRecordForCompanyBankBtn.vue?vue&type=template&id=209fe60e"
import script from "./NewRecordForCompanyBankBtn.vue?vue&type=script&lang=ts"
export * from "./NewRecordForCompanyBankBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports